import { KeycloakService } from "keycloak-angular";
import { AppService } from "@core/services/app.service";
import { tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AuthenticationInterceptorService implements HttpInterceptor {
  private appService = inject(AppService);
  private keycloakAngular = inject(KeycloakService);


  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const clonedRequest = request.clone();

    return next.handle(clonedRequest).pipe(
      tap(
        () => {},
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status !== 401) {
              return;
            }
            this.doLogout();
          }
        }
      )
    );
  }

  doLogout() {
    this.appService.logout().subscribe(
      (res) => {
        localStorage.removeItem("authToken");
        this.keycloakAngular.logout();
      },
      () => {
        localStorage.removeItem("authToken");
        this.keycloakAngular.logout();
      }
    );
  }
}
